/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "von {{count}}",
          "Page": "Seite",
          "PageOfCount": "{{current}} von {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "en",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "of {{count}}",
          "Page": "Page",
          "PageOfCount": "{{current}} of {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "es",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "de {{count}}",
          "Page": "Página",
          "PageOfCount": "{{current}} de {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "fr",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "sur {{count}}",
          "Page": "Page",
          "PageOfCount": "{{current}} sur {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "it",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "di {{count}}",
          "Page": "Pagina",
          "PageOfCount": "{{current}} di {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "ja",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "/{{count}}",
          "Page": "ページ",
          "PageOfCount": "{{current}}/{{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "nl",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "van {{count}}",
          "Page": "Pagina",
          "PageOfCount": "{{current}} van {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "Back": "Back",
      "Details": "Details",
      "Download": "Download",
      "DownloadAttachment": "Download Attachments",
      "FileMetadata": {
        "LastUpdated": "Last Updated",
        "Name": "Name",
        "Size": "Size"
      },
      "LastUpdated": "Last updated",
      "PdfViewer": {
        "Page": {
          "OfCount": "de {{count}}",
          "Page": "Página",
          "PageOfCount": "{{current}} de {{count}}"
        }
      },
      "WOPIEDITVIEWER": {
        "ERROR": "Error Loading Document"
      },
      "WatermarkCheckBox": {
        "AddWatermark": "Add a watermark",
        "FailedToCreateWatermarkResource": "Failed to create watermark resource",
        "FailedToDeleteWatermarkResource": "Failed to delete watermark resource",
        "NoResourcesProvidedError": "No resources provided.",
        "NoWatermarkedRidsProvidedError": "No watermarked RIDs provided.",
        "ResourceNotSupportedError": "Files cannot be shared. File type(s) or size(s) do not support watermarking."
      },
      "WatermarkViewer": {
        "AddedBy": "Added by",
        "DateAdded": "Date added",
        "Download": "Download",
        "Error": "Error loading file",
        "ItemSelection": "Select items to see actions",
        "MultipleFilesError": "Error loading files. Please try again later.",
        "Name": "Name",
        "Preview": "Preview",
        "Size": "Size"
      },
      "ZipViewer": {
        "AlertDescription": "The items in this zip are browse only. You can download the file to view the contents.",
        "Model": {
          "Content": "The file is large, do you want to download and view it?",
          "Title": "Download Confirmation"
        }
      }
    }
  }
];